import React, {useState,useMemo} from 'react';
import {Link,Redirect} from "react-router-dom";
import useStyles from './Styles';
import CopyToClipboard from 'react-copy-to-clipboard';
import Tooltip from '@mui/material/Tooltip';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import Chip from '@mui/material/Chip';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import {Inc,Owner,ReturnBaseSearchCondition,ReturnBase} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import ReturnListSearch from './ReturnListSearch';
import StoreImg from './StoreImg';
import Title from './Title';
import Yesno from './Yesno';
import Toast from './Toast';
import MultiLines from './MultiLines';
import AppBank from './AppBank';

interface ReturnListProps {
	owner:Owner,
	bank:AppBank,
}
let page:number = 1;

const ReturnList = (pr:ReturnListProps)=> {
    Ajax.setEditorId( pr.owner.owner_id );
    const classes = useStyles();
	const [toast,setToast] = useState('');
    const [states,setStates] = useState({
        bases:[] as ReturnBase[],
        isLoading:true,
		//editIndex:-1,
		deleteIndex:-1,
        pager:null,
        cond:Inc.defaultReturnBaseSearchCondition(),
    });
    const search = (cond:ReturnBaseSearchCondition,first?:boolean)=>{
        //console.log("search",cond);
        setStates({...states,deleteIndex:-1,"isLoading":true});
        window.scrollTo(0,0);
        if( first ){
            page = 1;
        }
        Ajax.search("takeback/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({bases:res.bases,deleteIndex:-1,cond:cond,pager:res.pager,isLoading:false});
            } else {
                setStates({...states,bases:[],deleteIndex:-1,pager:null,"isLoading":false});
            }
        });
    }
	//const openInput = (index:number)=>{
	//	setStates({...states,editIndex:index});
	//}
	//const closeInput = ()=>{
	//	setStates({...states,editIndex:-1});
	//}
	const openDelete = (index:number)=>{
		setStates({...states,deleteIndex:index});
	}
	const closeDelete = ()=>{
		setStates({...states,deleteIndex:-1});
	}
	const jump = (p:number)=>{
		//send(values,p);
		page = p;
		search(states.cond);
	}
	const ReturnRow = (props:{base:any,owner_id:number,index:number})=>{
		const [rowstate,setRowstate] = useState({open:false,items:[]});
		const toggle = async ()=>{			
			if( rowstate.items.length===0 ){
				const res = await Ajax.sendAwait("takeback/items",{return_base_id:props.base.return_base_id});
				//console.log(res);
				setRowstate({...rowstate,items:res.items,open:!rowstate.open});
				//setRowstate({...rowstate,open:!rowstate.open});
			} else {
				setRowstate({...rowstate,open:!rowstate.open});
			}
		}

		let tracking;
		if( props.base.how_id==='2' ){
			tracking = (<Box>井の頭倉庫</Box>);
		} else if(props.base.status==='0') {
			tracking = (<Box>{props.base.how_label}</Box>);
		}

		return (
			<>
			<TableRow>
				<TableCell className={classes.tableCellNowrap} style={{width:'4em'}} align='center'>
					{props.base.return_base_id}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{width:{md:'auto',lg:'6.5em'}}} align='center'>
					{props.base.created}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{width:{md:'auto',lg:'6.5em'}}} align='center'>
					<Box>{props.base.delivery_date}</Box>
				</TableCell>
				{props.base.status!=='0' ? (
				<TableCell className={classes.tableCellNowrap} align='center' sx={{display:{xs:'none',sm:'table-cell'}}}>
					{(props.base.how_id==='2' || !props.base.upack_code) ? (
					<Box>{props.base.how_label}</Box>
					):(
					<CopyToClipboard text={props.base.upack_code} onCopy={copyTracking}><Tooltip title="追跡番号をコピーする"><Button variant="text" size="small">{props.base.how_label} {props.base.upack_code}</Button></Tooltip></CopyToClipboard>
					)}
				</TableCell>
				):(
				<TableCell className={classes.tableCellNowrap} align='center' style={{color:'gray'}} sx={{display:{xs:'none',sm:'table-cell'}}}>
					{tracking}
				</TableCell>
				)}
				<TableCell className={classes.tableCellNowrap} style={{width:'4em'}} align='center'>
					{Tools.colorLabel("consign_status",props.base.status,props.base.status_label)}<br/>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="right" style={{width:'2em'}}><IconButton style={{margin:'0',padding:'0',marginRight:'0.5em'}} onClick={toggle}><ArrowDropDownIcon/></IconButton></TableCell>
			</TableRow>
			{rowstate.open &&
			<TableRow>
				<TableCell style={{ paddingBottom: '3em', paddingTop: 0, paddingLeft: '1em', paddingRight: 0}} colSpan={9}>
					{rowstate.items ? (
					<Table>
						<TableBody>
						{rowstate.items.map((item:any,index:number)=>{
							const key = "item"+index;
							return (
						<TableRow key={key}>
							<TableCell className={classes.tableCellDense} align="center" style={{width:'3em',verticalAlign:'middle'}}><StoreImg owner_id={props.owner_id} img_id={item.img_id} className="imgList"/></TableCell>
							<TableCell style={{width:'4em'}} sx={{display:{xs:'none',sm:'table-cell'}}}><span className={classes.itemId}>ID:{item.item_id}</span></TableCell>
							<TableCell>
								<Box sx={{display:{xs:'table-cell',sm:'none'}}}><span className={classes.itemId}>ID:{item.item_id}</span></Box>
								{item.item_name}
							</TableCell>
							<TableCell style={{width:'6em'}} align='right'>
								{item.su}{item.unit}
								{item.with_flag==='1' &&
								<Chip label="+サンプル" size="small" color="info"/>
								}
							</TableCell>
						</TableRow>
							)
						})}
						</TableBody>
					</Table>
					):(
					<Box style={{textAlign:'center',padding:'2em 0'}}>
						<CircularProgress />
					</Box>
					)}
					<Table>
						<TableBody>
							<TableRow sx={{display:{xs:'table-row',sm:'none'}}}>
								<TableCell style={{backgroundColor:'#F5F5F5'}}>
									配送情報
								</TableCell>
								{props.base.status!=='0' ? (
								<TableCell>
									{(props.base.how_id==='2' || !props.base.upack_code) ? (
									<Box>{props.base.how_label}</Box>
									):(
									<CopyToClipboard text={props.base.upack_code} onCopy={copyTracking}><Tooltip title="追跡番号をコピーする"><Button variant="text" size="small">{props.base.how_label} {props.base.upack_code}</Button></Tooltip></CopyToClipboard>
									)}
								</TableCell>
								):(
								<TableCell>
									{tracking}
								</TableCell>
								)}
							</TableRow>
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									お届け先
								</TableCell>
								<TableCell>
									〒{props.base.zip}<br/>
									{props.base.ken}{props.base.addr}<br/>
									TEL: {props.base.tel}<br/>
								</TableCell>
							</TableRow>
							{props.base.how_id==='1' &&
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									お届け希望日時
								</TableCell>
								<TableCell>
									<Box>{props.base.hope_date}</Box>
									<Box>{props.base.jikantai_label}</Box>
								</TableCell>
							</TableRow>
							}
							<TableRow>
								<TableCell sx={{backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
									備考
								</TableCell>
								<TableCell>
									<MultiLines text={props.base.memo} empty={true}/>
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
					<Box sx={{ marginTop:'0.5em', textAlign:'left' }}>
						<Button variant="text" size="small" color="error" disabled={props.base.status!=='0'} onClick={()=>openDelete(props.index)}><DeleteForeverIcon/>削除</Button>
					</Box>
				</TableCell>
			</TableRow>
			}
			</>
		);
	}
	const baseRows = useMemo(()=>{
		return states.bases.map((base:any,index:number)=>{
			const key = "base"+index;
			return <ReturnRow base={base} owner_id={pr.owner.owner_id} index={index} key={key}/>
		})
	},[states.bases])

	const deleteReturn = async ()=>{
		const id = states.bases[states.deleteIndex].return_base_id;
		setStates({...states,deleteIndex:-1,isLoading:true});
		const res = await Ajax.sendAwait("takeback/delete",{return_base_id:id});
		if( res.ok ){
			//setStates({...states,deleteIndex:-1,isLoading:false});
			search(states.cond);
		} else {
			setStates({...states,deleteIndex:-1,isLoading:false});
		}
	}

	const closeToast = ()=>{
		setToast('');
	}

	const copyTracking = ()=>{
		setToast('追跡番号をクリップボードにコピーしました');
	}

	if( pr.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}

	return (
		<div id="base_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="商品引取の履歴" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
	                        これまでに申請した商品引取の一覧です。手続の進捗を確認できます。<br/>
							<Box sx={{display:{md:'block',lg:'none'}}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
									<Button variant="contained" color="primary" style={{width:"100%"}} component={Link} to="/takeback"><AddIcon/>商品引取の申請</Button>
								</FormControl>
							</Box>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',lg:'table-cell'}}}>引取受付番号</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'table-cell',lg:'none'}}}>番号</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">申請日</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">発送予定日</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{display:{xs:'none',sm:'table-cell'}}}>配送情報</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">状態</TableCell>
									<TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>{baseRows}</TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} sx={{display:{md:'none',lg:'block'},marginBottom:"1em"}}>
						<Title text="商品を引き取る" size={2}/>
						<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
							<Button variant="contained" color="primary" style={{width:"100%"}} component={Link} to="/takeback"><AddIcon/>商品引取の申請</Button>
						</FormControl>
                        <ul className={classes.guideUl}>
                            <li className={classes.guideLi}>引き取り方法はゆうパック、ゆうパケット、または井の頭倉庫でのお渡しとなります</li>
							<li className={classes.guideLi}>ゆうパック、ゆうパケットの送料は売上残高から差し引きます。売上残高が足りない場合は着払い（ゆうパック）でのお届けとなります。</li>
							<li className={classes.guideLi}>引き取りと同時に支払申請をしたい場合は、まずは引き取りの手続きだけを行い、商品がお手元に届いてから支払申請を行って下さい。</li>
                        </ul>
					</Paper>
                    <Paper className={classes.paper}>
                        <ReturnListSearch update={search} bank={pr.bank} bankKey={"savedReturnListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>
			<Yesno mes="この申請を削除してよろしいですか？" isOpen={states.deleteIndex>=0} yes={deleteReturn} no={closeDelete}/>
            <Loading isLoading={states.isLoading}/>
			<Toast mes={toast} close={closeToast}/>
		</div>
	);
}

export default ReturnList;
